import Injector from 'vue-inject';

const DEFAULT_TITLE = 'Agent';

export default class TitleService {
  constructor() {
    this.agentTitle = DEFAULT_TITLE;
  }

  setTitle(title) {
    this.agentTitle = title || DEFAULT_TITLE;
    this.refreshTitle();
  }

  refreshTitle() {
    document.title = this.agentTitle;
    window.history.replaceState({}, document.title, document.location.href);
  }
}

Injector.service('titleService', [], TitleService);



// WEBPACK FOOTER //
// ./src/services/TitleService.js